<template>
    <div class="container mx-auto pt-2">
        <div class="flex flex-wrap">
            <div class="md:w-full pr-4 pl-4">
                <form enctype="multipart/form-data" action="/presale/checkout" method="POST">
                    <div class="py-3 px-2 mb-0 bg-dark border-b-1 border-gray-400">{{transEdit('treatments')}}</div>
<!--                    <h5 class="text-gray-500"></h5>-->
                    <ul class="flex flex-col pl-0 mb-0 border rounded border-gray-400 " v-if="cart.length > 0">
                        <li class="relative block py-3 px-6 -mb-px border border-r-0 border-l-0 border-gray-400" v-for="(product, index) in cart">
                            <input type="hidden" name="products[]" :value="product.id">
                            <input type="hidden" name="productQuantity[]" :value="product.quantity">
                            <div class="flex justify-between align-center ">
                                <div class="flex justify-between align-center">
                                    <div class="productPrice cartTotal">{{ product.quantity }} st &nbsp</div>
                                    <div class="">{{ product.name }}</div>
                                </div>
                                <div class="flex justify-between align-center">
                                    <div class="productPrice">{{ numberFormat(getPriceIncVat(product) * product.quantity) }} kr</div>
                                </div>
                            </div>
                        </li>
                        <li class="relative block py-3 px-6 -mb-px border border-r-0 border-l-0 border-gray-400" v-for="freeCoupon in cart.freeCoupons">
                            <div class="flex justify-between align-center text-green-500">
                                <div class="flex justify-between align-center">
                                    <div class="relative inline-flex align-middle flex-col items-start justify-center productPrice">
                                    </div>
                                    <div class="productPrice cartTotal">+ {{ freeCoupon.discount_amount }}</div>
                                    <div style="margin-left: 10px;"> {{ freeCoupon.treatment.name }}</div>
                                </div>
                                <div class="flex justify-between align-center">
                                    <div class="productPrice">0 kr</div>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div class="flex flex-row" style="margin-top: 5px;">
                        <div class="w-full">
                            <h6 class="cartSubTotal float-right ">{{transEdit('sum')}}: {{ numberFormat(cart.cartSubTotal) }} kr</h6><br>
                        </div>
                    </div>
                    <div class="flex flex-row">
                        <div class="w-full mb-1">
                            <h6 class="cartSubTotal float-right ">{{transEdit('vat')}}: {{ numberFormat(cart.cartVatTotal) }} kr</h6><br>
                        </div>
                    </div>
                    <div class="flex flex-row" v-show="cart.discountAmount !== 0">
                        <div class="w-full mb-1">
                            <h5 class="cartTotal float-right text-green-500" v-show="cart.discountAmount !== 0"> Rabatt: {{ cart.discountAmount }} kr</h5>
                        </div>
                    </div>
                    <div class="flex flex-row">
                        <div class="w-full">
                            <h4 class="cartTotal float-right "> {{transEdit('total')}}: {{ round2Digits(cart.cartTotal - cart.discountAmount) }} kr</h4>
                        </div>
                    </div>
                    <div class="mt-4 mb-8" v-if="availablePaymentMethods && availablePaymentMethods.length > 1">
                        <label class="block text-gray-800 font-weight-bold mb-3 text-lg">{{transEdit('customer_pages.choose-payment-method')}}</label>
                        <div class="flex flex-col gap-3">
                            <label v-for="(paymentMethod, index) in availablePaymentMethods" :key="paymentMethod.id" class="payment-method-option cursor-pointer flex items-center gap-4 p-4 rounded-lg border-2 border-gray-300 hover:border-gray-800 transition-all duration-200 bg-gray-100 hover:bg-gray-200">
                                <input type="radio" name="payment_method_id" :value="paymentMethod.id" class="payment-method-radio hidden" :checked="index === 0">
                                <span class="payment-method-check flex items-center justify-center w-6 h-6 rounded-full border-2 border-gray-400 flex-shrink-0 transition-all duration-200">
                                    <span class="payment-method-check-inner w-3 h-3 rounded-full bg-gray-800 opacity-0 transition-opacity duration-200"></span>
                                </span>
                                <span class="flex-1">
                                    <span class="block text-gray-800 font-weight-bold text-lg">{{ paymentMethod.display_name || paymentMethod.name }}</span>
                                </span>
                            </label>
                        </div>
                    </div>
                    <div v-else-if="availablePaymentMethods && availablePaymentMethods.length === 1">
                        <input type="hidden" name="payment_method_id" :value="availablePaymentMethods[0].id">
                    </div>
                    <div>
                    <button class="inline-block align-middle text-center select-none font-normal whitespace-no-wrap py-2 px-4 rounded text-base leading-normal text-green-100 bg-green-500 hover:bg-green-400" type="submit"><i class="fa fa-check"></i>  {{transEdit('pay')}}</button>
                    <button class="inline-block align-middle text-center select-none border border-red-500 font-normal whitespace-no-wrap py-2 px-4 rounded text-base leading-normal text-red-400 hover:bg-black-400" type="button" @click="$emit('close')"><i class="fa fa-ban"></i>  {{transEdit('cancel')}}</button>
                    </div>
                    <input type="hidden" name="_token" :value="csrf">
                    <input type="hidden" name="discount" v-model="cart.discountAmount">
                    <input type="hidden" name="is_subvention" v-model="has_subventions">
                </form>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        name: "modal",
        props: ['cart', 'subventions_left', 'has_subventions', 'available_payment_methods'],
        data() {
            return {
                order: [
                  { cartSubTotal: 0 },
                  { cartVatTotal: 0},
                  { cartTotal: 0},
                ],
                discountAmount: 0,
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            }
        },
        computed: {
            availablePaymentMethods() {
                return this.available_payment_methods || [];
            }
        },
        created() {
            this.$eventHub.$on('coupon-checkout', this.getOrder);
        },
        beforeDestroy() {
            this.$eventHub.$off('coupon-checkout');
        },
        methods: {
            numberFormat(val) {
                return window.number_format(val);
            },
            getPriceIncVat (product) {
                let vatInDecimals = product.vat / 100;

                return this.subventions_left ? product.prices[0].subv_price :(product.prices[0].full_price * (1 + vatInDecimals));
            },
            close() {
                this.$emit('close');
            },
            getOrder(cart) {
                this.order.cartSubTotal = cart.cartSubTotal;
                this.order.cartVatTotal = cart.cartVatTotal;
                this.order.cartTotal = cart.cartTotal;
                this.discountAmount = cart.discountAmount;
                this.cart = cart;
            },
            confirmCheckout(e = null) {
                e.preventDefault();

                let formData = new FormData(e.target);

                axios({
                    method: 'post',
                    url: '/presale/checkout',
                    data: formData,
                    contentType: false,
                    processData: false,
                }).then((response) => {
                    this.payModal_html = response.data;
                    if (response.data() == "ok")
                        this.closePayModalBox();
                });
            },
            round2Digits(number) {
                return window.number_format(Math.round( Math.round( number * 1000 ) / 10 ) / 100);
            },
        },
    }
</script>

<style scoped>
    .payment-method-option:has(.payment-method-radio:checked) {
        border-color: #1a1a1a;
        background-color: rgba(0, 0, 0, 0.1);
    }
    .payment-method-option:has(.payment-method-radio:checked) .payment-method-check {
        border-color: #1a1a1a;
        background-color: #1a1a1a;
    }
    .payment-method-option:has(.payment-method-radio:checked) .payment-method-check-inner {
        opacity: 1;
        background-color: #fff;
    }
</style>
